module.exports = __webpack_public_path__ + "okta-logo-6203da61f45544548e35f58560527136.webp";